module.exports = __webpack_public_path__ + "static/media/hab3-2.e0bed2c1.jpg";